<template>
  <Link href="/reviews/create" class="
            bg-brand-blue-400
            hover:bg-brand-blue-200
            text-white
            font-bold
            py-2
            px-4
            rounded
            uppercase
            text-center
          ">
  <slot>New Review</slot>
  </Link>
</template>

<script>

export default {
  methods: {
    onClickNewReview() {
      this.$inertia.visit('/reviews/create', {
        method: 'get',
        data: {
        },
      })
    }
  }
}
</script>